import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2"];

function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const groupInfo = {
  "group-1": [
    {
      label: "Driver Name",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "driver_name",
      type: "text",
      placeHolder: "",
      // url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      // suggestionSchema: {
      //   vehicle_id: "vehicle_id",
      //   vehicle_no: "vehicle_no",
      //   driver_name: "driver_name",
      //   owner_name: "owner_name",
      // },
      toValidate: false,
      regExpValidation: "[a-zA-z]",
      keyboardNavigationMap: {
        Enter: "vehicle_no",
      },
    },
    {
      label: "Vehicle No.",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "vehicle_no",
      type: "text",
      placeHolder: "1234",
      // apiConfigKey: "getVehicleSuggestions",
      // url: SERVER_URL + "/vehicle/",    #commented because we need only is_active vehicles only
      // url: SERVER_URL + "/vehicle/is_active",
      // suggestionKeyword: "vehicle_no",
      // suggestionKeywordForFetchApiArgs: "vehicle_no",
      // suggestionSchema: {
      //   vehicle_id: "vehicle_id",
      //   vehicle_no: "vehicle_no",
      //   driver_name: "driver_name",
      //   owner_name: "owner_name",
      //   tds_rate: "tds_rate",
      // },
      suggestionChooseQueryKeyword: "vehicle_no",
      apiCallRequiredOnGetValue: true,
      keyboardNavigationMap: {
        Enter: "station_name",
      },
      toValidate: true,
      regExpValidation: "^[a-zA-Z0-9]+$",
      valueVerificationFromSuggestionNeeded: true,
      valueVerificationCompulsionField: "vehicle_id",
    },
    {
      label: "Station To",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "station_name",
      type: "text",
      placeHolder: "",
      apiConfigKey: "getCitySuggestions",
      url: SERVER_URL + "/branch/",
      suggestionKeyword: "name",
      suggestionKeywordForFetchApiArgs: "name",
      suggestionSchema: {
        branch_id: "station_from",
        name: "station_from_name",
      },
      toValidate: true,
      regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "pkgs",
      },
    },
    // {
    //   label: "Amount",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "amount",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "[a-zA-z]",
    //   keyboardNavigationMap: {
    //     Enter: "pkgs",
    //   },
    // },
    {
      label: "Packages",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "pkgs",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "^(?:[0-9]+d*|d)$",
      keyboardNavigationMap: {
        Enter: "remarks",
      },
    },
  ],
  "group-2": [
    // {
    //   label: "Party Name",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "party_name",
    //   type: "text",
    //   placeHolder: "",
    //   // url: SERVER_URL + "/branch/",
    //   suggestionKeyword: "name",
    //   // suggestionSchema: {
    //   //   vehicle_id: "vehicle_id",
    //   //   vehicle_no: "vehicle_no",
    //   //   driver_name: "driver_name",
    //   //   owner_name: "owner_name",
    //   // },
    //   toValidate: false,
    //   regExpValidation: "[a-zA-z]",
    //   keyboardNavigationMap: {
    //     Enter: "remarks",
    //   },
    // },
    {
      label: "Remarks",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "remarks",
      type: "text",
      placeHolder: "",
      keyboardNavigationMap: {
        Enter: "silak",
      },
    },
    {
      label: "Silak",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "silak",
      type: "text",
      placeHolder: "",
      // apiConfigKey: "getCitySuggestions",
      // url: SERVER_URL + "/branch/",
      // suggestionKeyword: "name",
      // suggestionKeywordForFetchApiArgs: "name",
      // suggestionSchema: {
      //   branch_id: "payable_branch",
      //   name: "payable_branch_name",
      // },
      // toValidate: true,
      // regExpValidation: "[a-zA-z]",
      apiCallRequiredOnGetValue: true,
      suggestionChooseQueryKeyword: "branch_id",
      keyboardNavigationMap: {
        Enter: "left_pkgs",
      },
    },
    // {
    //   label: "Total Packages",
    //   className: "form-row",
    //   labelClassName: "form-label",
    //   inputClassName: "form-input",
    //   name: "total_pkgs",
    //   type: "text",
    //   placeHolder: "",
    //   toValidate: false,
    //   regExpValidation: "^(?:[0-9]+d*|d)$",
    //   keyboardNavigationMap: {
    //     Enter: "left_pkgs",
    //   },
    // },
    {
      label: "Left Packages",
      className: "form-row",
      labelClassName: "form-label",
      inputClassName: "form-input",
      name: "left_pkgs",
      type: "text",
      placeHolder: "",
      toValidate: false,
      regExpValidation: "^(?:[0-9]+d*|d)$",
      keyboardNavigationMap: {
        Enter: "print_button",
      },
    },
  ],
};

const dataObject = {
  mf_id: "",
  mf_no: "",
  driver_name: "",
  vehicle_no: "",
  vehicle_id: "",
  station_name: "",
  // station_from: "",
  // mf_date: formatDate(new Date()),
  // mf_date: new Date().toISOString(),
  mf_date: new Date(),
  pkgs: "",
  party_name: "",
  amount: "",
  remarks: "",
  silak: "",
  left_pkgs: "",
  bilty_ids: [],
  total_pkgs: "",
  created_by: "",
  created_from: "",
  last_mf_no: "",
  is_deleted: 0,
  suffix: "",
  suffix_options: [],
  bilty_no: "",
  packages: "",
  actual_packages: "",
  bilty_info: [],
};


const challanBiltyOriginalTableHeader = [
  { label: "S. No.", className: "text-center table-header" },
  { label: "Bilty No.", className: "text-center table-header" },
  { label: "MF No.", className: "text-center table-header" },
  { label: "Bilty Date", className: "text-center table-header" },
  { label: "Station From", className: "text-center table-header" },
  { label: "Station To", className: "text-center table-header" },
  { label: "Pay Type", className: "text-center table-header" },
  { label: "Consignor Name", className: "text-center table-header" },
  { label: "Consignee Name", className: "text-center table-header" },
  { label: "No Of Package", className: "text-center table-header" },
  { label: "Charge Weight", className: "text-center table-header" },
  { label: "Total Amount", className: "text-center table-header" },
];

const challanBiltyOriginalTableItems = [
  {
    type: "text",
    name: "bilty_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "mf_no",
    label: "Bilty No",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "bilty_date",
    label: "Bilty Date",
    className: "form-control-medium-col",
    convertFunction: (itemObject)=>{
      return formatDate(itemObject.bilty_date)
    }
  },
  {
    type: "text",
    name: "station_from",
    label: "Station From",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "station_to",
    label: "Station To",
    className: "form-control-medlarge-col",
  },
  {
    type: "text",
    name: "pay_type",
    label: "Pay Type",
    className: "form-control-medium-col",
  },
  {
    type: "text",
    name: "consignor_name",
    label: "Consignor Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "consignee_name",
    label: "Consignee Name",
    className: "form-control-large-col",
  },
  {
    type: "text",
    name: "no_of_package",
    label: "No Of Package",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "charge_weight",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
  {
    type: "text",
    name: "total_amount",
    label: "Charge Weight",
    className: "form-control-small-col",
  },
];

function validate(values) {
  let errors = {};

  function validator(value, regexp) {
    var regex = new RegExp(regexp);
    if (values.hasOwnProperty(value)) {
      if (!values[value].trim()) {
        errors[value] = "Required Field";
      } else if (!regex.test(values[value])) {
        errors[value] = "Validation Error";
      } else {
        errors[value] = "";
      }
    }
  }
  for (let group_name of groupNames) {
    for (let i = 0; i < groupInfo[group_name].length; i++) {
      console.log(groupInfo[group_name][i]);
      let field_object = groupInfo[group_name][i];
      if (field_object.toValidate) {
        validator(field_object.name, field_object.regExpValidation);
      }
    }
  }
  return errors;
}

const popupInfo = {
  success_header: "Marfatiya Saving Successful ",
  error_header: "Error In Marfatiya Module ",
  success_title: "Marfatiya is successfully created with the following info:-",
  field_label_success: "Marfatiya No.",
  field_name_success: "mf_no",
  error_title: "Error in Marfatiya module with the following info:-",
  field_label_error: "Error:",
};

export { 
  groupInfo,
  groupNames, 
  dataObject, 
  validate, 
  popupInfo,
  challanBiltyOriginalTableHeader,
  challanBiltyOriginalTableItems
};
